export default function toPostData(x) {
    return { postData: x };
}